const namespace = "TABBAR_";

const CONSTANTS = {
  TABBAR_TAB_LIST_GET: `${namespace}TAB_LIST_GET`,
  TABBAR_TAB_LIST_LOADING: `${namespace}TAB_LIST_LOADING`,
  TABBAR_TAB_LIST_SUCCESS: `${namespace}TAB_LIST_SUCCESS`,
  TABBAR_TAB_LIST_ERROR: `${namespace}TAB_LIST_ERROR`,
  GET_COURSE_COUPON_STUDENT_OVERVIEW: `${namespace}GET_COURSE_COUPON_STUDENT_OVERVIEW`,
};

export const TAB_BAR_ENUMS = {
  overview: 1,
  content: 2,
  liveClasses: 3,
  announcements: 4,
  trialContent:5,
  savedQuestions: 6,
};

export default CONSTANTS;
